import * as React from "react";
import { Path, G, ClipPath, Defs, Rect, Mask } from "react-native-svg";

import { Icon, IconProps } from "../../primitive";

export const ZMIcon = (props: IconProps) => (
  <Icon fill="none" viewBox="0 0 16 12" title="ZM" {...props}>
    <G clipPath="url(#a)">
      <Rect width={16} height={12} fill="#fff" rx={1} />
      <Path
        fill="#F7FCFF"
        fillRule="evenodd"
        d="M0 0h16v12H0V0Z"
        clipRule="evenodd"
      />
      <Path
        fill="#5EAA22"
        fillRule="evenodd"
        d="M0 0v12h16V0H0Z"
        clipRule="evenodd"
      />
      <Mask
        id="b"
        width={16}
        height={12}
        x={0}
        y={0}
        maskUnits="userSpaceOnUse"
        style={{
          maskType: "luminance",
        }}
      >
        <Path
          fill="#fff"
          fillRule="evenodd"
          d="M0 0v12h16V0H0Z"
          clipRule="evenodd"
        />
      </Mask>
      <G mask="url(#b)">
        <Path fill="#FF8126" d="M13 5h3v7h-3z" />
        <Path fill="#272727" d="M10 5h3v7h-3z" />
        <Path fill="#C51918" d="M7 5h3v7H7z" />
        <Path
          fill="#FF8126"
          d="M6.59 1.343c-.15-.099-.116-.45 0-.31.115.14 1.06.525 1.197.663.135.138-.024-.137-.136-.353-.112-.216.744.361 1.087.468.342.106.915.433.915.212 0-.22.266-.564.551-.68.286-.117.333.116.604.216.266.097.009.247 0 .252 0 0-.054-.063-.054-.115 0-.051-.207 0-.314.189-.107.188.107.177.314.177.208 0 .634-.039.79-.039.157 0 .231 0 .438-.138.207-.14 1.147-.326 1.277-.384.13-.057-.127.243-.13.247 0 0 1.006-.405 1.207-.544.202-.138-.07.139-.2.355-.131.216.347-.216.569-.355.22-.138-.057.237-.18.355-.121.117.288 0 .43-.118.14-.116-.085.203-.142.307-.057.104-.077.137.056.137.131 0-.332.361-.343.37.004 0 .14-.019 0 .224-.142.247-1.214.498-1.267.61-.05.114-.715.252-.667.252.049 0 .13.061.042.061s-.243.05-.243.05.081 0 0 .116c-.082.116-.29-.048-.175.117.116.164.075.106-.043.106s-.254-.106-.398-.106c-.144 0 .013.106.098.167.085.06.037.053-.141.053s-.188-.04-.188 0-.272-.114-.375-.114c-.102 0 .22.212.22.212s-.168-.054-.259-.098c-.09-.043.179.349.143.352-.038 0-.217-.123-.217-.046s.074.134.164.134c.09 0 .106.12.053.12-.054 0-.143-.065-.143 0 0 .067.09.094.09.219 0 .124-.134.142-.09.06.044-.084-.153-.283-.153-.185v.125c0 .142-.045.069-.103.142-.064.083-.02.095-.066.095-.047 0-.075-.177-.219-.237-.144-.06-.05.06-.15.142-.098.083 0 .09 0 .156s-.11-.066-.11-.156-.125-.209-.125-.142c0 .066 0 .142-.064.142s0 .096-.078.156c-.078.061 0-.06-.064-.156-.063-.095.064-.276 0-.209-.063.067-.144.067-.198.067-.054 0-.095.136-.095.06 0-.078.08-.278.23-.278.151 0 .205-.08.27-.121.063-.041 0-.095-.065-.134-.03-.019-.018-.08.004-.133.034-.022.06-.048.06-.075 0-.034-.036.015-.06.075a.318.318 0 0 1-.146.056c-.063 0 .064-.212.064-.343 0-.13.05-.223 0-.18-.05.041-.41-.043-.463-.043-.053 0 .111-.227 0-.166-.112.062-.355.05-.47.05-.114 0 .075-.159 0-.111a.408.408 0 0 1-.232.061c-.084 0-.036-.11-.16-.109-.123 0-.152-.001-.22-.055s.068-.065-.046-.065h-.337c-.167 0 .001-.131.062-.131.06 0 .13-.117 0-.064-.131.052-.277 0-.476 0-.199 0-.237-.093-.119-.093s.124-.068-.059-.068-.314-.079-.379-.079c-.064 0-.134-.09 0-.09.135 0 .307-.076.16-.076s-.468-.138-.555-.138c-.087 0 .495-.088.148-.088s-.718-.398-.856-.461 0-.188.04-.137c.04.052.32.132.198.063a.726.726 0 0 1-.238-.252c-.04-.064-.01-.108.04-.058.048.05.265.188.275.195a1.54 1.54 0 0 1-.216-.353c-.097-.216.095-.164.26 0 .165.163.32.206.398.216.077.009-.078-.118-.228-.216Zm3.957 2.13s.018.67-.047.67-.35.223-.07.223c.28 0 .449.223.364 0-.084-.223-.056-.127-.056-.304 0-.178-.19-.588-.19-.588Z"
        />
      </G>
    </G>
    <Defs>
      <ClipPath id="a">
        <Rect width={16} height={12} fill="#fff" rx={1} />
      </ClipPath>
    </Defs>
  </Icon>
);
